import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';

@Injectable()
export class AdminClustersService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'AdminClustersService');
  }

  checkCluster(id: any) {
    let serviceUrl = this.baseUrl + 'ClusterService' + '/checkCluster?clusterId=' + id;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  checkClusterCode(code: string, debtorId: number) {
    let serviceUrl =
      this.baseUrl +
      'ClusterService' +
      '/checkClusterCode?clusterCode=' +
      code +
      '&debtor=' +
      debtorId;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  checkDebtorId(id: number) {
    let serviceUrl = this.baseUrl + 'ClusterService' + '/checkDebtor?debtor=' + id;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  addCluster(params: any) {
    let serviceUrl = this.baseUrl + 'ClusterService' + '/saveCluster';
    return this.request(serviceUrl, this.setPostParams(params)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }

  getClusterList(id: any): Observable<any> {
    let serviceUrl = this.baseUrl + 'ClusterService' + '/getAllClusters?debtorId=' + id;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getPrefillFields(productcode: any): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'ClusterService' + '/getClusterFormFields?productcode=' + productcode;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getProductCodeList(): Observable<any> {
    let serviceUrl = this.baseUrl + 'ClusterService' + '/getAllProducts';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getPercentageValues(productCode: any): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'ClusterService' + '/getPercentageValue?productCode=' + productCode;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getClusterById(id: any): Observable<any> {
    let serviceUrl = this.baseUrl + 'ClusterService' + '/getCluster?clusterId=' + id;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  deleteCl(id: any): Observable<any> {
    let serviceUrl = this.baseUrl + 'ClusterService' + '/deleteCluster?clusterId=' + id;
    return this.request(serviceUrl, this.setPostParams(id)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  getInterestType(benchmarkRate, monthType) {
    let serviceUrl =
      this.baseUrl +
      'ClusterService' +
      '/getInterTypes?benchRate=' +
      benchmarkRate +
      '&monthType=' +
      monthType;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getFields(fourEyes: boolean, fourEyesRequestId: string): Observable<any> {
    // uncomment for local development of clusterForm
    // return this.http.get('/assets/formly/abc/clusterForm.json').pipe(map(super.extractData),catchError(super.handleError));

    return this.request(
      this.baseUrl +
        'FormDataService/configData?formCd=Cluster_Form&langId=2&fourEyesRequestId=' +
        fourEyesRequestId +
        '&fourEyes=' +
        fourEyes /* , this.setGetParams(bean) */,
    ).pipe(map(this.extractData), catchError(this.handleError));
  }

  getBenchmarkFlow(param1: any): Observable<any> {
    let langId = this.getActiveLang();
    let serviceUrl =
      this.baseUrl + 'ClusterService' + '/getBenchmarkFlow?param1=' + param1 + '&langId=' + langId;
    return this.request(serviceUrl).pipe(map(this.extractData), catchError(this.handleError));
  }

  getTermsAndConditionsList(): Observable<any> {
    let serviceUrl = this.baseUrl + 'TermsAndConditionsService' + '/getAllTermsAndConditions';
    return this.request(serviceUrl).pipe(map(this.extractData), catchError(this.handleError));
  }

  getTermsAndConditionsListWithoutBlobs(): Observable<any> {
    let serviceUrl = this.baseUrl + 'TermsAndConditionsService' + '/getAllTermsAndConditions?withoutBlobs=true';
    return this.request(serviceUrl).pipe(map(this.extractData), catchError(this.handleError));
  }

  getInterestTypeRefIds(param1: any): Observable<any> {
    let langId = this.getActiveLang();
    let serviceUrl =
      this.baseUrl +
      'ClusterService' +
      '/getInterestTypeRefIds?param1=' +
      param1 +
      '&langId=' +
      langId;
    return this.request(serviceUrl).pipe(map(this.extractData), catchError(this.handleError));
  }

  getInitData(id: any) {
    let serviceUrl = this.baseUrl + 'ClusterService' + '/getInitData?debtor=' + id;
    return this.request(serviceUrl).pipe(map(this.extractData), catchError(this.handleError));
  }
}
